import { useEffect, useState } from "react";
import { createUser, fetchAllServices, fetchAllUsers, updateUser } from "./user.service";

export const useCloudUsersQuery = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // Should be null, not true

  const loadUsers = async () => {
    setLoading(true);
    setError(null); // Reset error before fetching
    try {
      const data = await fetchAllUsers();
      setUsers(data || []);
    } catch (err) {
      setError(err); // Set actual error object
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const refetch = async () => {
    await loadUsers();
  };

  return { users, loading, error, refetch };
};

export const useUsersMutation = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleMutation = async (mutationFn, data, id = null) => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const result = id ? await mutationFn(id, data) : await mutationFn(data);
      setSuccess(true);
      return result;
    } catch (err) {
      console.error("User mutation error:", err);
      setError(err.response?.data || err.message);
      setSuccess(false);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const create = (userData) => handleMutation(createUser, userData);

  const update = (userId, userData) => handleMutation(updateUser, userData, userId);

  return { create, update, loading, error, success };
};

export const useServicesQuery = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadServices = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchAllServices();
      setServices(data || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadServices();
  }, []);

  const refetch = async () => {
    await loadServices();
  };

  return { services, loading, error, refetch };
};